import React, { useRef, useState, useEffect } from "react";
// import { createPortal } from "react-dom";
import QyqwHeader from "../Component/QyqwHeader";
import TabList from "../Component/TabList";
import {
  queryArchivesList,
  queryAllChannel,
  queryFileList,
} from "../../../service";
import { Link } from "react-router-dom";
import bg1 from "../../../assets/images/QYQW/webp/qhxz_bg1.webp";
import bg2 from "../../../assets/images/QYQW/webp/qhxz_bg2.webp";
import right from "../../../assets/images/QYQW/qyqw-next-icon.png";
import left from "../../../assets/images/QYQW/qyqw-last-icon.png";
import musicIcon from "../../../assets/images/QYQW/QHXZ/music_icon.png";
import musicPlay from "../../../assets/images/QYQW/QHXZ/music_play.png";
import back2Icon from "../../../assets/images/iframeclose.png";
import { useNav } from "../../../App";
import { flattenChannels } from "../../../utils/platform";
import { useLocation } from "react-router-dom";
import "./index.scss";
const bgImg = {
  FamousAppreciation: bg1,
  "QHXZ-MustRead": bg2,
  GQSelectedTrack: bg2,
};
export default function QHXZ() {
  const [list, setList] = useState([]);
  const [pageSize, setPageSize] = useState(1);
  const [allPage, setAllPage] = useState(1);
  const [iframeVisible, setIframeVisible] = useState(false);

  const { pathname } = useLocation();

  const channelNo = pathname?.split("/")?.[2];
  const { navData2 } = useNav();
  const flattenedChannels = flattenChannels(navData2);

  let channeldata = flattenedChannels?.filter((item) => {
    return item.channelNo === channelNo;
  })?.[0];

  let channeldataP = flattenedChannels?.filter((item) => {
    return item.channelNo === channeldata?.parentChannelNo;
  })?.[0];
  const qhxzRef = useRef();

  useEffect(() => {
    if (channelNo !== "FamousAppreciation" || pageSize === 1) {
      setPageSize(1);
      setList([]);
    }

    if (qhxzRef.current) {
      qhxzRef.current.style.backgroundImage = `url(${bgImg[channelNo]})`;
    }

    queryArchivesList({
      pagination: {
        size: channelNo === "FamousAppreciation" ? 4 : 999,
        page: pageSize,
      },
      resource: channelNo === "FamousAppreciation" ? "YZQS" : channelNo,
    }).then((res) => {
      let newList = res.records;
      if (res.records) {
        newList = newList.map((item) => {
          if (item.imgSrc) item.imgSrc = window.ENV_IMG_PREURL + item.imgSrc;
          if (item.appImgSrc) item.appImgSrc = window.ENV_IMG_PREURL + item.appImgSrc;
          return item;
        });

        setList(newList);
        setAllPage(res.pages);
      }
    });
  }, [channelNo, pageSize]);
  return (
    <div className="qhxz-page" ref={qhxzRef}>
      <QyqwHeader title={channeldataP?.channelName} />
      {channelNo === "FamousAppreciation" && (
        <ul className={`qhxz-list ${channelNo}-list`}>
          {list.map((item) => (
            <li
              className="qhxz-list-item"
              key={item.id}
              onClick={() => {
                setIframeVisible(item.linkUrl)
              }}
            >
              <div>
                <div className="item-top">
                  <img src={item.imgSrc} className="q_img" alt="" />
                  <div className="top_mask" />
                </div>

                <div className="q_name">{item.title}</div>
              </div>
            </li>
          ))}
        </ul>
      )}
      {channelNo === "QHXZ-MustRead" && (
        <ul className={`qhxz-list ${channelNo}-list`}>
          {list.map((item) => (
            <li className="qhxz-list-item" key={item.id}>
              <Link to={item.linkUrl || `/GQKP/${channelNo}/${item.id}`}>
                <div className="item-top">
                  <img src={item.appImgSrc} class="q_img" alt="" />
                  {/* <div className="top_mask" /> */}
                </div>

                <div className="q_name">{item.title}</div>
              </Link>
            </li>
          ))}
        </ul>
      )}
      {channelNo === "GQSelectedTrack" && <QQJX No={channelNo} />}
      {allPage > 1 && channelNo === "FamousAppreciation" && (
        <div className="qhxz-pager">
          <img
            src={left}
            alt=""
            onClick={() => {
              if (pageSize > 1) setPageSize(pageSize - 1);
            }}
          />
          {pageSize}/{allPage}
          <img
            src={right}
            alt=""
            onClick={() => {
              if (pageSize < allPage) setPageSize(pageSize + 1);
            }}
          />
        </div>
      )}
      <TabList No="QHXZ" defaultTab={channelNo} iframeVisible={iframeVisible} />
      {iframeVisible && (
        <iframe title="文物" src={iframeVisible} className="iframe-box" />
      )}
      {iframeVisible && (
        <img
          src={back2Icon}
          className="Iframe-back"
          alt=""
          onClick={() => {
            setIframeVisible("");
          }}
        />
      )}
    </div>
  );
}

const QQJX = ({ No }) => {
  const [levelData, setLevelData] = useState({});
  const [isPlayUrl, setIsPlayUrl] = useState("");
  const [playId, setPlayId] = useState("");

  // const [musicLoad, setMusicLoad] = useState(false);

  const audio = useRef();
  useEffect(() => {
    audio.current = new Audio();
    audio.current.preload = "auto";
    queryAllChannel(No).then((res) => {
      let levelArr = res.records;
      let levelData = {};
      let proList = levelArr.map((item) => {
        return queryArchivesList({
          pagination: {
            size: 999,
            page: 1,
          },
          resource: item.channelNo,
        }).then((res) => {
          levelData[item.channelNo] = {
            name: item.channelName,
            data: res.records,
          };
        });
      });
      Promise.all(proList)
        .then(() => {
          const newLevelData = {};
          levelArr.forEach((ele) => {
            newLevelData[ele.channelNo] = levelData[ele.channelNo];
          });

          setLevelData(newLevelData);
        })
        .catch((err) => {
          console.error(err);
        });
    });

    return () => {
      if (audio.current) {
        audio.current.pause();
        audio.current.src = "";
      }
    };
  }, [No]);

  useEffect(() => {
    if (isPlayUrl) {
      audio.current.src = isPlayUrl;
      audio.current.addEventListener("canplaythrough", handleProgress);
      audio.current.play();
    } else {
      audio.current && audio.current.pause();
    }

    return () => {
      audio.current &&
        audio.current.removeEventListener("canplaythrough", handleProgress);
    };
  }, [isPlayUrl]);

  const handleProgress = (e) => {
    console.log("加载中完成");
    // setMusicLoad(false);
  };

  const StartMusic = (id, groupId) => {
    if (isPlayUrl && playId === id) {
      setIsPlayUrl("");
      setPlayId("");
      audio.current.src = "";
      return;
    }
    setPlayId(id);
    // setMusicLoad(true);
    queryFileList({
      pagination: {
        size: 0,
        page: 0,
      },
      params: {
        groupId: groupId,
        code: "CMS_ARCHIVES_FILE",
      },
    }).then((res1) => {
      let musicUrl =
        res1?.records?.filter((item) => {
          return item.type === "mp3";
        }) || [];
      if (musicUrl.length > 0) setIsPlayUrl(musicUrl[0].filePath);
    });
  };
  return (
    <div className="qqjx_con">
      {Object.keys(levelData).map((key) => {
        return (
          <div className="qqjs_item">
            <div className="qqjs_title">{levelData[key].name}</div>
            <ul className="qqjs_list">
              {levelData[key].data.map((item) => {
                return (
                  <li className="qqjs_list_item">
                    <div className="list_a">
                      <div className="qqjs_name">{item.title}</div>
                      <div className="qqjs_name2">演奏者：{item.subTitle}</div>
                      <img
                        // src={
                        //   musicLoad && playId === item.id
                        //     ? musicLoadIcon
                        //     : musicIcon
                        // }
                        src={playId === item.id ? musicPlay : musicIcon}
                        className="music_icon"
                        alt="play_icon"
                        onClick={() => {
                          StartMusic(item.id, item.groupId);
                        }}
                      />
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </div>
  );
};
